export default __webpack_public_path__ + "static/media/BrainBreak cards45.ac54dd30.png";